import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { PaymentMethod } from '../../services/dto/payment-method';

export const paymentMethodLabel = (paymentMethod: PaymentMethod) =>
  `project.paymentMethod.${PaymentMethod[paymentMethod]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrl: './payment-method.component.scss',
  imports: [BadgeComponent, TranslatePipe],
})
export class PaymentMethodComponent extends CamBaseComponent {
  status = input.required<number | PaymentMethod>();

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  public label() {
    return paymentMethodLabel(this.status());
  }

  public type() {
    switch (this.status()) {
      case PaymentMethod.DirectDebit:
        return 'success';
      case PaymentMethod.BankTransfer:
        return 'purple';
      case PaymentMethod.Unknown:
      default:
        return 'info';
    }
  }
}
